const messageList = {
    "User not found": "Usuario no encontrado.",
    "Vault not found": "Bóveda no encontrada",
    "Wrong password": "Contraseña incorrecta.",
    "Invalid credential": "Credencial no válida",
    "Verify code is wrong": "El código ingresado no es correcto. Verifícalo e intenta nuevamente.",
    "Verify code was expired": "El código de verificación ha expirado. Reenvíe la solicitud para restablecer su contraseña.",
    "Not found reset password request": "No se encontró la solicitud de restablecimiento de contraseña",
    "Not found kyc information": "No se encontró información de KYC",
    "KYC was not approved yet": "KYC aún no ha sido aprobado",
    "You didn't accept the terms of services yet": "Aún no has aceptado los términos del servicio",
    "User already exists": "La usuario ya existe",
    "Invalid phonenumber": "Número de teléfono inválido",
    "Not verified by phone": "No verificado por teléfono",
    "Password is not matched": 'La contraseña no coincide.',
    "Missing image": 'Imagen faltante',
    "Invalid base64 image format": 'Formato de imagen base64 no válido',
    "The customer is not authorized to create MXN Virtual Accounts": "El cliente no está autorizado para crear Cuentas Virtuales MXN",
    "The beneficiary address is not valid": "La dirección del beneficiario no es válida",
    "Liquidation address not found": "Dirección de liquidación no encontrada",
    "Wallet Balance is not enough": "El saldo de la billetera no es suficiente",
    "Not allowed country": "País no permitido",
    "not allowed currency": "moneda no permitida",
    "Not allowed account type": "Tipo de cuenta no permitido",
    "Empty bank name": "Nombre del banco vacío",
    "Empty bank image": "Imagen de banco vacía",
    "Empty bank account owner name": "Nombre del propietario de la cuenta bancaria vacía",
    "BankAccountOwnerName's length must have 3 to 35 characters and only contain printable ASCII characters": "La longitud de BankAccountOwnerName debe tener entre 3 y 35 caracteres y solo contener caracteres ASCII imprimibles.",
    "account_owner_type is required": "Se requiere account_owner_type",
    "Not allowed account_owner_type": "No se permite el tipo de propietario de la cuenta",
    "first_name and last_name are required": "first_name y last_name son obligatorios",
    "business_name is required": "Se requiere nombre_empresa",
    "iban field is required": "El campo iban es obligatorio",
    "clabe field is required": "El campo clabe es obligatorio",
    "address field is required": "El campo de dirección es obligatorio",
    "Not allowed payment_rail": "Pago no permitido_rail",
    "Not found beneficiary": "No se encontró beneficiario",
    "Not found business vault account": "No se encontró la cuenta de bóveda empresarial",
    "Liquidation address is not approved by administrator": "La dirección de liquidación no está aprobada por la administradora",
    "External Account not found": "Cuenta externa no encontrada",
    "You have attempted to log in more than 5 times": "Has intentado iniciar sesión más de 5 veces. Intenta iniciar sesión después de 1 minuto.",
    "Admin not found": "No se encontró el administrador",

    "Server error": "Error Interno del Servidor.",
    "Network Error": 'Error de red',
    "Transfer Success": "Se transmitió con precisión"
}

const findMessage = (msg) => {
    return messageList[msg] ?? "Error Interno del Servidor.";
}

export default findMessage;